import React, { useEffect, useRef, useState } from "react";
import {
  getOperators,
  createOperator,
  updateOperator,
  getConfig,
  getAllOperators,
} from "../../services/api";
const getId = (item) => item?._id || item?.id || item || "";

import {
  FiEdit,
  FiEye,
  FiSearch,
  FiMapPin,
  FiExternalLink,
} from "react-icons/fi";

import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import WifiIcon from "@mui/icons-material/Wifi";
import CableIcon from "@mui/icons-material/Cable";
import { MdOutlinePermMedia } from "react-icons/md";
import MediaGallery from "../MediaGallery/MediaGallery";
import { CameraswitchOutlined } from "@mui/icons-material";

import { getPageNumbers } from "../../helpers/Helpers";
import globalStyles, { COLORS } from "../../styles/globalStyles";

const API_ORIGIN = (process.env.REACT_APP_API_URL || "")
  .replace(/\/$/, "")
  .replace(/\/api\/?$/, "");

const s = {
  viewImage: {
    width: 160,
    height: 110,
    borderRadius: 8,
    objectFit: "cover",
    border: "1px solid #e5e7eb",
  },

  srow: {
    display: "flex",
    gap: 10,
  },
  businessDropdownWrap: {
    position: "relative",
  },

  businessDropdownInput: {
    height: "auto",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 6,
    cursor: "pointer",
  },

  businessPlaceholder: {
    color: "#000000",
    fontSize: 14,
    fontWeight: 499,
  },

  businessChip: {
    background: "#ede9fe",
    color: COLORS.primary,
    border: `1px solid ${COLORS.primary}`,
    borderRadius: 999,
    padding: "4px 9px",
    fontSize: 12,
    fontWeight: 500,
    lineHeight: 0.7,
  },

  businessDropdownMenu: {
    position: "absolute",
    top: "calc(100% + 6px)",
    left: 0,
    right: 0,
    zIndex: 20,
    background: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: 10,
    boxShadow: "0 12px 28px rgba(15, 23, 42, 0.14)",
    padding: 10,
  },

  businessOption: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "8px 10px",
    cursor: "pointer",
    fontSize: 13,
    color: "#334155",
  },

  businessSelectAll: {
    fontWeight: 700,
    color: COLORS.primary,
    borderBottom: "1px solid #f1f5f9",
  },
};

const blank = {
  name: "",
  phone: "",
  email: "",
  businessName: "",
  businessType: [],
  address: "",
  geo: {
    latitude: "",
    longitude: "",
    landmark: "",
  },
  infrastructure: {
    isp: "",
    subscriberCount: "",
    technicians: "",
  },
  communication: {
    preferredLanguage: "",
  },
  awareness: {
    knowsCompany: false,
    source: "",
  },
  assignedTo: "",
  notes: "",
  referenceBy: "",
};

const OperatorTile = ({ value, label, icon: Icon, color, active, onClick }) => (
  <div
    style={{ ...globalStyles.tile, ...(active ? globalStyles.activeTile : {}) }}
    onClick={onClick}
  >
    <div style={globalStyles.tileIcon(color)}>
      <Icon fontSize="medium" />
    </div>

    <div style={globalStyles.tileText}>
      <div style={globalStyles.tileValue}>{value ?? 0}</div>
      <div style={globalStyles.tileLabel}>{label}</div>
    </div>
  </div>
);

export default function Operators() {
  const [operators, setOperators] = useState([]);
  const [operatorList, setOperatorList] = useState([]);

  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(blank);
  const [err, setErr] = useState("");
  const [fieldErr, setFieldErr] = useState({});

  const [mapData, setMapData] = useState(null);
  const [view, setView] = useState(null);

  const [page, setPage] = useState(1);
  const [limit] = useState(20);

  const [totalPages, setTotalPages] = useState(1);
  const [isLastPage, setIsLastPage] = useState(false);

  const [search, setSearch] = useState("");
  const [businessTypeFilter, setBusinessTypeFilter] = useState("");

  const [businessTypes, setBusinessTypes] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [mediaModal, setMediaModal] = useState(null);
  const [operatorCounts, setOperatorCounts] = useState({
    total: 0,
    broadband: 0,
    digitalCable: 0,
    cctv: 0,
  });
  const [businessTypeDropdownOpen, setBusinessTypeDropdownOpen] =
    useState(false);
  const businessTypeDropdownRef = useRef(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        businessTypeDropdownRef.current &&
        !businessTypeDropdownRef.current.contains(event.target)
      ) {
        setBusinessTypeDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getImageUrl = (imagePath) => {
    if (!imagePath) return "";

    const value = String(imagePath).replace(/\\/g, "/");

    if (
      value.startsWith("http://") ||
      value.startsWith("https://") ||
      value.startsWith("blob:") ||
      value.startsWith("data:")
    ) {
      return value;
    }

    if (!API_ORIGIN) {
      return value.startsWith("/") ? value : `/${value}`;
    }

    return `${API_ORIGIN}${value.startsWith("/") ? value : `/${value}`}`;
  };

  const formatBusinessType = (value) => {
    if (Array.isArray(value)) return value.join(", ");

    return value || "—";
  };

  const formatDateTime = (value) => {
    if (!value) return "—";

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) return "—";

    return date.toLocaleString("en-IN", {
      day: "numeric",
      month: "long",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  const getCreatedByName = (createdBy) => {
    if (!createdBy) return "—";

    if (typeof createdBy === "object") {
      return createdBy.name || createdBy.email || createdBy.employeeId || "—";
    }

    return String(createdBy);
  };

  const normalizeBusinessTypes = (value) => {
    if (Array.isArray(value)) {
      return value.map((item) => String(item).trim().toLowerCase());
    }

    if (typeof value === "string" && value) {
      return value.split(",").map((item) => item.trim().toLowerCase());
    }

    return [];
  };

  const load = async () => {
    setLoading(true);

    try {
      const [
        operatorResponse,
        allOperatorResponse,
        operatorListResponse,
        configResponse,
      ] = await Promise.allSettled([
        getOperators({
          page,
          limit,
          search,
          businessType: businessTypeFilter,
        }),

        getOperators({ limit: 1000 }),

        getAllOperators(),

        getConfig(),
      ]);

      const operatorData =
        operatorResponse.status === "fulfilled"
          ? operatorResponse.value?.data?.data || {}
          : {};

      const apiOperators = Array.isArray(operatorData)
        ? operatorData
        : operatorData.operators || [];

      const operatorListData =
        operatorListResponse.status === "fulfilled"
          ? operatorListResponse.value?.data?.data || []
          : [];

      const apiOperatorList = Array.isArray(operatorListData)
        ? operatorListData
        : operatorListData.operators || [];

      const allOperatorData =
        allOperatorResponse.status === "fulfilled"
          ? allOperatorResponse.value?.data?.data || {}
          : {};

      const allOperators = Array.isArray(allOperatorData.operators)
        ? allOperatorData.operators
        : [];

      const getTypeCount = (type) => {
        return allOperators.filter((operator) => {
          const types = normalizeBusinessTypes(operator.businessType);
          return types.includes(type);
        }).length;
      };

      setOperatorCounts({
        total: allOperatorData.total || allOperators.length,
        broadband: getTypeCount("broadband"),
        digitalCable: getTypeCount("digital cable"),
        cctv: getTypeCount("cctv"),
      });

      const configData =
        configResponse.status === "fulfilled"
          ? configResponse.value?.data?.data || {}
          : {};

      const dynamicBusinessTypes = Array.isArray(configData.businessTypes)
        ? configData.businessTypes.map((type) =>
            String(type).trim().toLowerCase(),
          )
        : ["digital cable", "broadband", "cctv"];

      const dynamicLanguages = Array.isArray(configData.supportedLanguages)
        ? configData.supportedLanguages
        : [];

      setOperators(apiOperators);
      setOperatorList(apiOperatorList);
      setTotalPages(operatorData.totalPages || 1);
      setIsLastPage(operatorData.isLastPage || false);

      setBusinessTypes(dynamicBusinessTypes);
      setLanguages(dynamicLanguages);
    } catch (error) {
      console.error("Operators load error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [page, search, businessTypeFilter]);

  const _norm = (v) =>
    String(v || "")
      .trim()
      .toLowerCase();

  const totalOperators = operatorCounts.total;
  const broadbandCount = operatorCounts.broadband;
  const digitalcableCount = operatorCounts.digitalCable;
  const cctvCount = operatorCounts.cctv;

  const resetForm = () => {
    setForm({
      ...blank,
      assignedTo: "",
      geo: { ...blank.geo },
      infrastructure: { ...blank.infrastructure },
      communication: { ...blank.communication },
      awareness: { ...blank.awareness },
    });
  };

  const getFieldError = (key) => {
    const error = fieldErr[key];

    if (Array.isArray(error)) return error[0];

    if (typeof error === "object" && error?.message) {
      return error.message;
    }

    return error || "";
  };

  const openCreate = () => {
    resetForm();
    setEditing(null);
    setErr("");
    setFieldErr({});
    setModal(true);
  };

  const openEdit = (operator) => {
    setForm({
      name: operator.name || "",
      phone: operator.phone || "",
      email: operator.email || "",
      businessName: operator.businessName || "",
      businessType: normalizeBusinessTypes(operator.businessType),
      address: operator.address || "",

      geo: {
        latitude: operator.geo?.latitude ?? "",
        longitude: operator.geo?.longitude ?? "",
        landmark: operator.geo?.landmark || "",
      },

      infrastructure: {
        isp: operator.infrastructure?.isp || "",
        subscriberCount: operator.infrastructure?.subscriberCount ?? "",
        technicians: operator.infrastructure?.technicians ?? "",
      },

      communication: {
        preferredLanguage: operator.communication?.preferredLanguage || "",
      },

      awareness: {
        knowsCompany: operator.awareness?.knowsCompany || false,
        source: operator.awareness?.source || "",
      },
      assignedTo: getId(operator.assignedTo) || "",
      notes: operator.notes || "",
      referenceBy: operator.referenceBy || "",
    });

    setEditing(getId(operator));
    setErr("");
    setFieldErr({});
    setModal(true);
  };

  const openView = (operator) => {
    setView(operator);
  };

  const set = (path, value) => {
    const keys = path.split(".");

    setForm((prev) => {
      const next = { ...prev };

      if (keys.length === 1) {
        next[keys[0]] = value;
      } else {
        next[keys[0]] = {
          ...next[keys[0]],
          [keys[1]]: value,
        };
      }

      return next;
    });
  };

  const handleBusinessTypeTileClick = (businessType) => {
    setBusinessTypeFilter(businessType);
    setPage(1);
  };

  const buildOperatorPayload = () => {
    const payload = {
      name: form.name?.trim(),
      phone: form.phone?.trim(),
      email: form.email?.trim() || "",
      businessName: form.businessName?.trim() || "",
      businessType: Array.isArray(form.businessType)
        ? form.businessType.map((type) => String(type).trim().toLowerCase())
        : [],
      address: form.address?.trim(),

      geo: {
        latitude:
          form.geo?.latitude === "" || form.geo?.latitude === null
            ? ""
            : Number(form.geo?.latitude),
        longitude:
          form.geo?.longitude === "" || form.geo?.longitude === null
            ? ""
            : Number(form.geo?.longitude),
        landmark: form.geo?.landmark?.trim() || "",
      },

      infrastructure: {
        isp: form.infrastructure?.isp?.trim() || "",
        subscriberCount:
          form.infrastructure?.subscriberCount === "" ||
          form.infrastructure?.subscriberCount === null
            ? 0
            : Number(form.infrastructure?.subscriberCount),
        technicians:
          form.infrastructure?.technicians === "" ||
          form.infrastructure?.technicians === null
            ? 0
            : Number(form.infrastructure?.technicians),
      },

      communication: {
        preferredLanguage: form.communication?.preferredLanguage?.trim() || "",
      },

      awareness: {
        knowsCompany: Boolean(form.awareness?.knowsCompany),
        source: form.awareness?.source?.trim() || "",
      },
      notes: form.notes?.trim() || "",
      referenceBy: form.referenceBy?.trim() || "",
    };

    if (form.assignedTo) {
      payload.assignedTo = form.assignedTo;
    }

    return payload;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setErr("");
    setFieldErr({});

    const selectedBusinessTypes = Array.isArray(form.businessType)
      ? form.businessType.filter((type) => String(type).trim())
      : [];

    if (selectedBusinessTypes.length === 0) {
      setFieldErr({
        businessType: "Business Type is required",
      });
      setErr("");
      return;
    }

    const payload = buildOperatorPayload();

    try {
      if (editing) {
        await updateOperator(editing, payload);
      } else {
        await createOperator(payload);
      }

      setModal(false);
      resetForm();
      setEditing(null);
      load();
    } catch (error) {
      const apiErrors = error.response?.data?.errors || {};
      const message = error.response?.data?.message || "Operation failed";

      if (Object.keys(apiErrors).length > 0) {
        setFieldErr(apiErrors);
        setErr("");
      } else {
        setFieldErr({});
        setErr(message);
      }
    }
  };

  return (
    <div
      style={{
        ...globalStyles.contentWrapper,
        ...(isMobile ? globalStyles.responsive.mobileContentWrapper : {}),
      }}
    >
      <div style={globalStyles.row}>
        <h1 style={globalStyles.h1}>Operators</h1>

        <button
          type="button"
          style={{
            ...globalStyles.btn,
            ...(isMobile ? { width: "100%", justifyContent: "center" } : {}),
          }}
          onClick={openCreate}
        >
          + Add Operator
        </button>
      </div>

      <div
        style={{
          ...globalStyles.tilesGrid,
          ...(isMobile ? globalStyles.responsive.mobileTilesGrid : {}),
        }}
      >
        <OperatorTile
          value={totalOperators}
          label="Total Operators"
          icon={SupportAgentIcon}
          color="#06b6d4"
          active={_norm(businessTypeFilter) === ""}
          onClick={() => handleBusinessTypeTileClick("")}
        />

        <OperatorTile
          value={broadbandCount}
          label="Broadband"
          icon={WifiIcon}
          color="#2563eb"
          active={_norm(businessTypeFilter) === "broadband"}
          onClick={() => handleBusinessTypeTileClick("broadband")}
        />

        <OperatorTile
          value={digitalcableCount}
          label="Digital Cable"
          icon={CableIcon}
          color="#f59e0b"
          active={_norm(businessTypeFilter) === "digital cable"}
          onClick={() => handleBusinessTypeTileClick("digital cable")}
        />

        <OperatorTile
          value={cctvCount}
          label="CCTV"
          icon={CameraswitchOutlined}
          color="#8b5cf6"
          active={_norm(businessTypeFilter) === "cctv"}
          onClick={() => handleBusinessTypeTileClick("cctv")}
        />
      </div>

      <div
        style={{
          ...globalStyles.toolbar,
          ...(isMobile ? globalStyles.responsive.mobileToolbar : {}),
        }}
      >
        <div
          style={{
            ...globalStyles.filterLeft,
            ...(isMobile ? globalStyles.responsive.mobileFilterLeft : {}),
          }}
        >
          <div
            style={{
              ...globalStyles.searchWrap,
              ...(isMobile ? globalStyles.responsive.mobileSearchWrap : {}),
            }}
          >
            <FiSearch style={globalStyles.searchIcon} />

            <input
              style={globalStyles.searchInput}
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
              placeholder="Search operators..."
            />
          </div>
          {/* 
          <select
            style={{
              ...globalStyles.filterSelect,
              ...(isMobile ? globalStyles.responsive.mobileFilterSelect : {}),
            }}
            value={businessTypeFilter}
            onChange={(e) => handleBusinessTypeTileClick(e.target.value)}
          >
            <option value="">All Business Types</option>

            {businessTypes.map((type) => {
              const value = String(type).trim().toLowerCase();

              return (
                <option key={value} value={value}>
                  {value === "cctv"
                    ? "CCTV"
                    : value
                        .split(" ")
                        .map(
                          (word) =>
                            word.charAt(0).toUpperCase() + word.slice(1),
                        )
                        .join(" ")}
                </option>
              );
            })}
          </select> */}
        </div>
        <span style={globalStyles.paginatePageInfo}>
          Page {page} of {totalPages}
        </span>
      </div>

      {loading ? (
        <div style={globalStyles.loading}>Loading...</div>
      ) : (
        <div style={globalStyles.tableScroll}>
          <table style={globalStyles.table}>
            <thead>
              <tr>
                <th style={globalStyles.th}>Name</th>
                <th style={globalStyles.th}>Phone</th>
                <th style={globalStyles.th}>Network Name</th>
                <th style={globalStyles.th}>Type</th>
                <th style={globalStyles.th}>Map</th>
                <th style={globalStyles.th}>Added By</th>
                <th style={globalStyles.th}>Actions</th>
              </tr>
            </thead>

            <tbody>
              {operators.length > 0 ? (
                operators.map((operator) => {
                  const hasMap =
                    operator.geo?.latitude && operator.geo?.longitude;

                  return (
                    <tr key={getId(operator)}>
                      <td style={globalStyles.td}>
                        <strong>{operator.name || "—"}</strong>
                        <br />
                        <span style={{ fontSize: 12, color: "#94a3b8" }}>
                          {operator.businessName || "—"}
                        </span>
                      </td>

                      <td style={globalStyles.td}>{operator.phone || "—"}</td>

                      <td style={globalStyles.td}>
                        {operator.businessName || "—"}
                      </td>

                      <td style={globalStyles.td}>
                        {formatBusinessType(operator.businessType)}
                      </td>

                      <td style={globalStyles.td}>
                        {hasMap ? (
                          <div
                            title={`${operator.geo?.latitude}, ${operator.geo?.longitude}`}
                            style={globalStyles.mapBtn}
                            onClick={() => setMapData(operator.geo)}
                          >
                            <FiMapPin size={14} />
                          </div>
                        ) : (
                          "—"
                        )}
                      </td>

                      <td style={globalStyles.td}>
                        {operator.createdBy?.name || "—"}
                      </td>

                      <td style={globalStyles.td}>
                        <div style={globalStyles.btnRow}>
                          <button
                            type="button"
                            title="View"
                            style={globalStyles.viewBtn}
                            onClick={() => openView(operator)}
                          >
                            <FiEye size={14} />
                          </button>

                          <button
                            type="button"
                            title="Edit"
                            style={globalStyles.editBtn}
                            onClick={() => openEdit(operator)}
                          >
                            <FiEdit size={14} />
                          </button>

                          <button
                            type="button"
                            title="Media"
                            style={globalStyles.mediaBtn}
                            onClick={() => setMediaModal(operator)}
                          >
                            <MdOutlinePermMedia size={16} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td
                    colSpan="7"
                    style={{ ...globalStyles.td, ...globalStyles.emptyState }}
                  >
                    No Operators Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {!loading && totalPages > 1 && (
        <div style={globalStyles.paginateRow}>
          <button
            type="button"
            style={{
              ...globalStyles.paginateBtn,
              opacity: page === 1 ? 0.5 : 1,
            }}
            disabled={page === 1}
            onClick={() => setPage(1)}
          >
            {"<<"}
          </button>

          <button
            type="button"
            style={{
              ...globalStyles.paginateBtn,
              opacity: page === 1 ? 0.5 : 1,
            }}
            disabled={page === 1}
            onClick={() => setPage((prev) => prev - 1)}
          >
            {"<"}
          </button>

          {getPageNumbers(page, totalPages).map((pageNumber) => (
            <button
              key={pageNumber}
              type="button"
              style={{
                ...globalStyles.paginateBtn,
                background:
                  page === pageNumber ? COLORS.primary : COLORS.background,
                color: page === pageNumber ? COLORS.white : COLORS.primary,
                minWidth: 36,
              }}
              onClick={() => setPage(pageNumber)}
            >
              {pageNumber}
            </button>
          ))}

          <button
            type="button"
            style={{
              ...globalStyles.paginateBtn,
              opacity: isLastPage ? 0.5 : 1,
            }}
            disabled={isLastPage}
            onClick={() => setPage((prev) => prev + 1)}
          >
            {">"}
          </button>

          <button
            type="button"
            style={{
              ...globalStyles.paginateBtn,
              opacity: isLastPage ? 0.5 : 1,
            }}
            disabled={isLastPage}
            onClick={() => setPage(totalPages)}
          >
            {">>"}
          </button>
        </div>
      )}

      {modal && (
        <div style={globalStyles.modal}>
          <div
            style={{
              ...globalStyles.mcard,
              ...(isMobile ? globalStyles.responsive.mobileModalCard : {}),
            }}
          >
            <div style={globalStyles.modalHeader}>
              <h2 style={globalStyles.modalTitle}>
                {editing ? "Edit Operator" : "Add Operator"}
              </h2>

              <button
                type="button"
                style={globalStyles.modalCloseBtn}
                onClick={() => setModal(false)}
              >
                ✕
              </button>
            </div>

            {err && (
              <div style={{ color: "#ef4444", marginBottom: 12, fontSize: 13 }}>
                {err}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div
                style={{
                  ...s.srow,
                  ...(isMobile ? globalStyles.responsive.mobileFormRow : {}),
                }}
              >
                <div style={globalStyles.half}>
                  <label style={globalStyles.label}>Name *</label>
                  <input
                    style={{
                      ...globalStyles.input,
                      ...(getFieldError("name") ? globalStyles.inputError : {}),
                    }}
                    value={form.name}
                    onChange={(e) => set("name", e.target.value)}
                  />
                  {getFieldError("name") && (
                    <div style={globalStyles.errorText}>
                      {getFieldError("name")}
                    </div>
                  )}
                </div>

                <div style={globalStyles.half}>
                  <label style={globalStyles.label}>Phone *</label>
                  <input
                    style={{
                      ...globalStyles.input,
                      ...(getFieldError("phone")
                        ? globalStyles.inputError
                        : {}),
                    }}
                    value={form.phone}
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => set("phone", e.target.value)}
                  />
                  {getFieldError("phone") && (
                    <div style={globalStyles.errorText}>
                      {getFieldError("phone")}
                    </div>
                  )}
                </div>
              </div>
              <div
                style={{
                  ...s.srow,
                  ...(isMobile ? globalStyles.responsive.mobileFormRow : {}),
                }}
              >
                <div style={globalStyles.half}>
                  <label style={globalStyles.label}>Email</label>
                  <input
                    style={{
                      ...globalStyles.input,
                      ...(getFieldError("email")
                        ? globalStyles.inputError
                        : {}),
                    }}
                    type="email"
                    value={form.email}
                    onChange={(e) => set("email", e.target.value)}
                  />
                  {getFieldError("email") && (
                    <div style={globalStyles.errorText}>
                      {getFieldError("email")}
                    </div>
                  )}
                </div>

                <div style={globalStyles.half}>
                  <label style={globalStyles.label}>Network Name</label>
                  <input
                    style={{
                      ...globalStyles.input,
                      ...(getFieldError("businessName")
                        ? globalStyles.inputError
                        : {}),
                    }}
                    value={form.businessName}
                    onChange={(e) => set("businessName", e.target.value)}
                  />
                  {getFieldError("businessName") && (
                    <div style={globalStyles.errorText}>
                      {getFieldError("businessName")}
                    </div>
                  )}
                </div>
              </div>
              <div
                style={{
                  ...s.srow,
                  ...(isMobile ? globalStyles.responsive.mobileFormRow : {}),
                }}
              >
                <div style={globalStyles.half}>
                  <label style={globalStyles.label}>Address *</label>
                  <input
                    style={{
                      ...globalStyles.input,
                      ...(getFieldError("address")
                        ? globalStyles.inputError
                        : {}),
                    }}
                    value={form.address}
                    onChange={(e) => set("address", e.target.value)}
                    placeholder="Enter full address"
                  />
                  {getFieldError("address") && (
                    <div style={globalStyles.errorText}>
                      {getFieldError("address")}
                    </div>
                  )}
                </div>
              </div>
              <div
                style={{
                  ...s.srow,
                  ...(isMobile ? globalStyles.responsive.mobileFormRow : {}),
                }}
              >
                <div style={globalStyles.half}>
                  <label style={globalStyles.label}>Landmark</label>
                  <input
                    style={{
                      ...globalStyles.input,
                      ...(getFieldError("geo.landmark")
                        ? globalStyles.inputError
                        : {}),
                    }}
                    value={form.geo?.landmark}
                    onChange={(e) => set("geo.landmark", e.target.value)}
                  />
                  {getFieldError("geo.landmark") && (
                    <div style={globalStyles.errorText}>
                      {getFieldError("geo.landmark")}
                    </div>
                  )}
                </div>

                <div style={globalStyles.half}>
                  <label style={globalStyles.label}>Business Type *</label>

                  <div
                    style={s.businessDropdownWrap}
                    ref={businessTypeDropdownRef}
                  >
                    <div
                      onClick={() =>
                        setBusinessTypeDropdownOpen((prev) => !prev)
                      }
                      style={{
                        ...globalStyles.input,
                        ...s.businessDropdownInput,
                        ...(getFieldError("businessType")
                          ? globalStyles.inputError
                          : {}),
                      }}
                    >
                      {form.businessType.length > 0 ? (
                        form.businessType.map((type) => (
                          <span key={type} style={s.businessChip}>
                            {type === "cctv"
                              ? "CCTV"
                              : type
                                  .split(" ")
                                  .map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1),
                                  )
                                  .join(" ")}
                          </span>
                        ))
                      ) : (
                        <span style={s.businessPlaceholder}>
                          Select Business Type
                        </span>
                      )}
                    </div>

                    {businessTypeDropdownOpen && (
                      <div style={s.businessDropdownMenu}>
                        <label
                          style={{
                            ...s.businessOption,
                            ...s.businessSelectAll,
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={
                              form.businessType.length === businessTypes.length
                            }
                            onChange={(e) => {
                              set(
                                "businessType",
                                e.target.checked
                                  ? businessTypes.map((type) =>
                                      String(type).trim().toLowerCase(),
                                    )
                                  : [],
                              );
                            }}
                          />
                          Select All
                        </label>

                        {businessTypes.map((type) => {
                          const value = String(type).trim().toLowerCase();
                          const checked = form.businessType.includes(value);

                          return (
                            <label key={value} style={s.businessOption}>
                              <input
                                type="checkbox"
                                checked={checked}
                                onChange={(e) => {
                                  const updatedTypes = e.target.checked
                                    ? [...form.businessType, value]
                                    : form.businessType.filter(
                                        (item) => item !== value,
                                      );

                                  set("businessType", updatedTypes);
                                }}
                              />

                              {value === "cctv"
                                ? "CCTV"
                                : value
                                    .split(" ")
                                    .map(
                                      (word) =>
                                        word.charAt(0).toUpperCase() +
                                        word.slice(1),
                                    )
                                    .join(" ")}
                            </label>
                          );
                        })}
                      </div>
                    )}
                  </div>

                  {getFieldError("businessType") && (
                    <div style={globalStyles.errorText}>
                      {getFieldError("businessType")}
                    </div>
                  )}
                </div>
              </div>
              {editing && (
                <div
                  style={{
                    ...s.srow,
                    ...(isMobile ? globalStyles.responsive.mobileFormRow : {}),
                  }}
                >
                  <div style={globalStyles.half}>
                    <label style={globalStyles.label}>Latitude</label>
                    <input
                      style={{
                        ...globalStyles.input,
                        ...(getFieldError("geo.latitude")
                          ? globalStyles.inputError
                          : {}),
                      }}
                      type="number"
                      step="any"
                      value={form.geo?.latitude}
                      onChange={(e) =>
                        set(
                          "geo.latitude",
                          e.target.value === ""
                            ? ""
                            : parseFloat(e.target.value),
                        )
                      }
                    />
                    {getFieldError("geo.latitude") && (
                      <div style={globalStyles.errorText}>
                        {getFieldError("geo.latitude")}
                      </div>
                    )}
                  </div>

                  <div style={globalStyles.half}>
                    <label style={globalStyles.label}>Longitude</label>
                    <input
                      style={{
                        ...globalStyles.input,
                        ...(getFieldError("geo.longitude")
                          ? globalStyles.inputError
                          : {}),
                      }}
                      type="number"
                      step="any"
                      value={form.geo?.longitude}
                      onChange={(e) =>
                        set(
                          "geo.longitude",
                          e.target.value === ""
                            ? ""
                            : parseFloat(e.target.value),
                        )
                      }
                    />
                    {getFieldError("geo.longitude") && (
                      <div style={globalStyles.errorText}>
                        {getFieldError("geo.longitude")}
                      </div>
                    )}
                  </div>
                </div>
              )}
              <div
                style={{
                  ...s.srow,
                  ...(isMobile ? globalStyles.responsive.mobileFormRow : {}),
                }}
              >
                <div style={globalStyles.half}>
                  <label style={globalStyles.label}>Provider</label>
                  <input
                    style={{
                      ...globalStyles.input,
                      ...(getFieldError("infrastructure.isp")
                        ? globalStyles.inputError
                        : {}),
                    }}
                    value={form.infrastructure?.isp}
                    onChange={(e) => set("infrastructure.isp", e.target.value)}
                  />
                  {getFieldError("infrastructure.isp") && (
                    <div style={globalStyles.errorText}>
                      {getFieldError("infrastructure.isp")}
                    </div>
                  )}
                </div>

                <div style={globalStyles.half}>
                  <label style={globalStyles.label}>Subscriber Count</label>
                  <input
                    style={{
                      ...globalStyles.input,
                      ...(getFieldError("infrastructure.subscriberCount")
                        ? globalStyles.inputError
                        : {}),
                    }}
                    min={0}
                    type="number"
                    value={form.infrastructure?.subscriberCount}
                    onKeyPress={(e) => {
                      if (e.key === "-") {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) =>
                      set("infrastructure.subscriberCount", e.target.value)
                    }
                  />
                  {getFieldError("infrastructure.subscriberCount") && (
                    <div style={globalStyles.errorText}>
                      {getFieldError("infrastructure.subscriberCount")}
                    </div>
                  )}
                </div>
              </div>
              <div
                style={{
                  ...s.srow,
                  ...(isMobile ? globalStyles.responsive.mobileFormRow : {}),
                }}
              >
                <div style={globalStyles.half}>
                  <label style={globalStyles.label}>Technicians</label>
                  <input
                    style={{
                      ...globalStyles.input,
                      ...(getFieldError("infrastructure.technicians")
                        ? globalStyles.inputError
                        : {}),
                    }}
                    min={0}
                    type="number"
                    value={form.infrastructure?.technicians}
                    onKeyPress={(e) => {
                      if (e.key === "-") {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) =>
                      set("infrastructure.technicians", e.target.value)
                    }
                  />
                  {getFieldError("infrastructure.technicians") && (
                    <div style={globalStyles.errorText}>
                      {getFieldError("infrastructure.technicians")}
                    </div>
                  )}
                </div>

                <div style={globalStyles.half}>
                  <label style={globalStyles.label}>Preferred Language</label>
                  <select
                    style={{
                      ...globalStyles.select,
                      ...(getFieldError("communication.preferredLanguage")
                        ? globalStyles.inputError
                        : {}),
                    }}
                    value={form.communication?.preferredLanguage}
                    onChange={(e) =>
                      set("communication.preferredLanguage", e.target.value)
                    }
                  >
                    <option value="">Select Preferred Language</option>

                    {languages.map((language) => (
                      <option key={language.key} value={language.value}>
                        {language.displayName}
                      </option>
                    ))}
                  </select>
                  {getFieldError("communication.preferredLanguage") && (
                    <div style={globalStyles.errorText}>
                      {getFieldError("communication.preferredLanguage")}
                    </div>
                  )}
                </div>
              </div>
              <div
                style={{
                  ...s.srow,
                  ...(isMobile ? globalStyles.responsive.mobileFormRow : {}),
                }}
              >
                <div style={globalStyles.half}>
                  <label style={globalStyles.label}>Knows Company</label>
                  <select
                    style={globalStyles.select}
                    value={form.awareness?.knowsCompany ? "true" : "false"}
                    onChange={(e) =>
                      set("awareness.knowsCompany", e.target.value === "true")
                    }
                  >
                    <option value="false">No</option>
                    <option value="true">Yes</option>
                  </select>
                </div>

                <div style={globalStyles.half}>
                  <label style={globalStyles.label}>Awareness Source</label>
                  <input
                    style={{
                      ...globalStyles.input,
                      ...(getFieldError("awareness.source")
                        ? globalStyles.inputError
                        : {}),
                    }}
                    value={form.awareness?.source}
                    onChange={(e) => set("awareness.source", e.target.value)}
                    placeholder="referral / field visit / website"
                  />
                  {getFieldError("awareness.source") && (
                    <div style={globalStyles.errorText}>
                      {getFieldError("awareness.source")}
                    </div>
                  )}
                </div>
              </div>
              <div
                style={{
                  ...s.srow,
                  ...(isMobile ? globalStyles.responsive.mobileFormRow : {}),
                }}
              >
                <div style={globalStyles.full}>
                  <label style={globalStyles.label}>Reference By</label>

                  <select
                    style={globalStyles.select}
                    value={form.referenceBy}
                    onChange={(e) => set("referenceBy", e.target.value)}
                  >
                    <option value="">Select Reference Operator</option>

                    {operatorList.map((op) => (
                      <option key={getId(op)} value={getId(op)}>
                        {op.name || "No Name"} {op.phone ? `(${op.phone})` : ""}
                      </option>
                    ))}
                  </select>

                  {getFieldError("referenceBy") && (
                    <div style={globalStyles.errorText}>
                      {getFieldError("referenceBy")}
                    </div>
                  )}
                </div>
              </div>
              <div
                style={{
                  ...s.srow,
                  ...(isMobile ? globalStyles.responsive.mobileFormRow : {}),
                }}
              >
                <div style={globalStyles.full}>
                  <label style={globalStyles.label}>Notes</label>
                  <textarea
                    style={{
                      ...globalStyles.textarea,
                      ...(getFieldError("notes")
                        ? globalStyles.inputError
                        : {}),
                    }}
                    value={form.notes}
                    onChange={(e) => set("notes", e.target.value)}
                    placeholder="Visited the site, owner was interested..."
                  />
                  {getFieldError("notes") && (
                    <div style={globalStyles.errorText}>
                      {getFieldError("notes")}
                    </div>
                  )}
                </div>
              </div>
              <div
                style={{
                  ...globalStyles.mrow,
                  ...(isMobile ? { justifyContent: "stretch" } : {}),
                }}
              >
                <button
                  type="button"
                  style={{
                    ...globalStyles.cancel,
                    ...(isMobile ? { width: "100%" } : {}),
                  }}
                  onClick={() => setModal(false)}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  style={{
                    ...globalStyles.btn,
                    ...(isMobile
                      ? { width: "100%", justifyContent: "center" }
                      : {}),
                  }}
                >
                  {editing ? "Update" : "Create"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {view && (
        <div style={globalStyles.modal}>
          <div
            style={{
              ...globalStyles.mcard,
              ...(isMobile ? globalStyles.responsive.mobileModalCard : {}),
            }}
          >
            <div style={globalStyles.modalHeader}>
              <h2 style={globalStyles.modalTitle}>View Operator</h2>

              <button
                type="button"
                style={globalStyles.modalCloseBtn}
                onClick={() => setView(null)}
              >
                ✕
              </button>
            </div>

            <div
              style={{
                ...globalStyles.viewGrid,
                ...(isMobile ? { gridTemplateColumns: "1fr" } : {}),
              }}
            >
              <div style={globalStyles.viewItem}>
                <div style={globalStyles.viewLabel}>Name</div>
                <div style={globalStyles.viewValue}>{view.name || "—"}</div>
              </div>

              <div style={globalStyles.viewItem}>
                <div style={globalStyles.viewLabel}>Phone</div>
                <div style={globalStyles.viewValue}>{view.phone || "—"}</div>
              </div>

              <div style={globalStyles.viewItem}>
                <div style={globalStyles.viewLabel}>Email</div>
                <div style={globalStyles.viewValue}>{view.email || "—"}</div>
              </div>

              <div style={globalStyles.viewItem}>
                <div style={globalStyles.viewLabel}>Network Name</div>
                <div style={globalStyles.viewValue}>
                  {view.businessName || "—"}
                </div>
              </div>

              <div style={globalStyles.viewItem}>
                <div style={globalStyles.viewLabel}>Business Type</div>
                <div style={globalStyles.viewValue}>
                  {formatBusinessType(view.businessType)}
                </div>
              </div>

              <div style={globalStyles.viewItem}>
                <div style={globalStyles.viewLabel}>Address</div>
                <div style={globalStyles.viewValue}>{view.address || "—"}</div>
              </div>

              <div style={globalStyles.viewItem}>
                <div style={globalStyles.viewLabel}>Latitude</div>
                <div style={globalStyles.viewValue}>
                  {view.geo?.latitude ?? "—"}
                </div>
              </div>

              <div style={globalStyles.viewItem}>
                <div style={globalStyles.viewLabel}>Longitude</div>
                <div style={globalStyles.viewValue}>
                  {view.geo?.longitude ?? "—"}
                </div>
              </div>

              <div style={globalStyles.viewItem}>
                <div style={globalStyles.viewLabel}>Landmark</div>
                <div style={globalStyles.viewValue}>
                  {view.geo?.landmark || "—"}
                </div>
              </div>

              {/* <div style={globalStyles.viewItem}>
                <div style={globalStyles.viewLabel}>Address Image</div>
                <div style={globalStyles.viewValue}>
                  {view.addressImg ? (
                    <img
                      src={getImageUrl(view.addressImg)}
                      alt="Address"
                      style={globalStyles.viewImage}
                    />
                  ) : (
                    "No Image"
                  )}
                </div>
              </div> */}

              <div style={globalStyles.viewItem}>
                <div style={globalStyles.viewLabel}>Provider</div>
                <div style={globalStyles.viewValue}>
                  {view.infrastructure?.isp || "—"}
                </div>
              </div>

              <div style={globalStyles.viewItem}>
                <div style={globalStyles.viewLabel}>Subscriber Count</div>
                <div style={globalStyles.viewValue}>
                  {view.infrastructure?.subscriberCount ?? "—"}
                </div>
              </div>

              <div style={globalStyles.viewItem}>
                <div style={globalStyles.viewLabel}>Technicians</div>
                <div style={globalStyles.viewValue}>
                  {view.infrastructure?.technicians ?? "—"}
                </div>
              </div>

              <div style={globalStyles.viewItem}>
                <div style={globalStyles.viewLabel}>Preferred Language</div>
                <div style={globalStyles.viewValue}>
                  {view.communication?.preferredLanguage || "—"}
                </div>
              </div>

              <div style={globalStyles.viewItem}>
                <div style={globalStyles.viewLabel}>Knows Company</div>
                <div style={globalStyles.viewValue}>
                  {view.awareness?.knowsCompany ? "Yes" : "No"}
                </div>
              </div>

              <div style={globalStyles.viewItem}>
                <div style={globalStyles.viewLabel}>Awareness Source</div>
                <div style={globalStyles.viewValue}>
                  {view.awareness?.source || "—"}
                </div>
              </div>

              <div style={globalStyles.viewItem}>
                <div style={globalStyles.viewLabel}>Reference By</div>

                <div style={globalStyles.viewValue}>
                  {view.referenceBy || "—"}
                </div>
              </div>

              <div style={globalStyles.viewItem}>
                <div style={globalStyles.viewLabel}>Notes</div>
                <div style={globalStyles.viewValue}>{view.notes || "—"}</div>
              </div>

              <div style={globalStyles.viewItem}>
                <div style={globalStyles.viewLabel}>Created By</div>
                <div style={globalStyles.viewValue}>
                  {getCreatedByName(view.createdBy)}
                </div>
              </div>

              <div style={globalStyles.viewItem}>
                <div style={globalStyles.viewLabel}>Created At</div>
                <div style={globalStyles.viewValue}>
                  {formatDateTime(view.createdAt)}
                </div>
              </div>
            </div>

            <div
              style={{
                ...globalStyles.mrow,
                ...(isMobile ? { justifyContent: "stretch" } : {}),
              }}
            >
              <button
                type="button"
                style={{
                  ...globalStyles.cancel,
                  ...(isMobile ? { width: "100%" } : {}),
                }}
                onClick={() => setView(null)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {mapData && (
        <div style={globalStyles.mapOverlay}>
          <div style={globalStyles.mapCard}>
            <div style={globalStyles.mapHeader}>
              <div>
                <div style={globalStyles.mapTitle}>Location Coordinates</div>

                <div style={globalStyles.mapCoords}>
                  {mapData.latitude}, {mapData.longitude}
                </div>
              </div>

              <button
                type="button"
                style={globalStyles.closeBtn}
                onClick={() => setMapData(null)}
              >
                ✕
              </button>
            </div>

            <iframe
              title="map"
              width="100%"
              height="260"
              style={globalStyles.mapFrame}
              loading="lazy"
              src={`https://maps.google.com/maps?q=${mapData.latitude},${mapData.longitude}&z=15&output=embed`}
            />

            <button
              type="button"
              style={globalStyles.mapActionBtn}
              onClick={() =>
                window.open(
                  `https://www.google.com/maps?q=${mapData.latitude},${mapData.longitude}`,
                  "_blank",
                )
              }
            >
              <FiExternalLink size={14} />
              Open in Google Maps
            </button>
          </div>
        </div>
      )}

      {mediaModal && (
        <MediaGallery
          operator={mediaModal}
          onClose={() => setMediaModal(null)}
        />
      )}
    </div>
  );
}
